// extracted by mini-css-extract-plugin
module.exports = {"mobileCursor":"index-module--mobileCursor--2Arf8"};